<script setup lang="ts">
import type { AcReminder } from "~/types/application";
import { ref } from 'vue'

const emits = defineEmits(["reminder-added", "cancelled"])

const reminder = ref<Partial<AcReminder>>({
    date: "",
    additionalMessage: "",
})

// Get tomorrow's date in YYYY-MM-DD format for min date
const getTomorrowDate = () => {
    const tomorrow = new Date()
    tomorrow.setDate(tomorrow.getDate() + 1)
    return tomorrow.toISOString().split('T')[0]
}

const minDate = getTomorrowDate()

// Convert date picker value to DD/MM/YYYY format
const handleDateChange = (event: Event) => {
    const target = event.target as HTMLInputElement
    const dateValue = target.value // This will be in YYYY-MM-DD format from date picker
    
    if (dateValue) {
        // Extract year to check if it's a complete/reasonable date
        const [year, month, day] = dateValue.split('-')
        
        // Only validate if the year is complete (4 digits) and reasonable
        if (year && year.length === 4 && parseInt(year) >= new Date().getFullYear()) {
            const selectedDate = new Date(dateValue)
            const tomorrow = new Date()
            tomorrow.setDate(tomorrow.getDate() + 1)
            tomorrow.setHours(0, 0, 0, 0)
            
            if (selectedDate < tomorrow) {
                // Reset the input if date is today or earlier
                target.value = ""
                reminder.value.date = ""
                alert("Hatırlatma tarihi bugünden sonraki bir tarih olmalıdır.")
                return
            }
        }
        
        // Convert YYYY-MM-DD to DD/MM/YYYY (only if we have all parts)
        if (year && month && day && year.length === 4) {
            reminder.value.date = `${day}/${month}/${year}`
        }
    } else {
        reminder.value.date = ""
    }
}

const addReminder = () => {
    emits("reminder-added", reminder.value)
}

</script>

<template>
    <form @submit.prevent="addReminder" class="ac-main-form !border-none">

        <p class="form-explanation text-2xl mb-8">
            Hatırlatma mesajı, seçeceğiniz tarihte sabah saat 09:00'da, göreve sorumlu olarak eklenen tüm kullanıcılara gönderilir.
            Eğer hatırlatma mesajını siz de almak istiyorsanız, lütfen potansiyelin sorumlular listesinde olduğunuzdan emin olun.
        </p>

        <div class="ac-form-control">
            <label for="reminderDate">Hatırlatma Tarihi</label>
            <input 
                type="date" 
                id="reminderDate" 
                :min="minDate"
                @change="handleDateChange"
            >
        </div>

        <div class="ac-form-control">
            <label for="reminderMessage">Hatırlatma Mesajı</label>
            <textarea placeholder="Hatırlatma için ek bir mesaj girmek istiyorsanız buradan girebilirsiniz." id="reminderMessage" v-model="reminder.additionalMessage"></textarea>
        </div>

        <div class="ac-button-row flex items-center justify-center gap-4">
            <button type="submit" class="ac-primary-button">Gönder</button>
            <button type="button" class="ac-secondary-button" @click="emits('cancelled')">İptal</button>
        </div>


    </form>
</template>